<template>
  <div
    id="login"
    class="bg-grey-light w-100 h-100 overflow-hidden position-fixed zIndex-18"
  >
    <div class="container">
      <div class="w-100 h-100 vh-100 d-table px-5">
        <div class="w-100 h-100 d-table-cell align-middle px-md-5">
          <div class="mx-md-5 px-md-5">
            <div
              class="mx-auto text-center bg-white p-5 rounded-lg shadow-lg position-relative"
            >
              <div class="mx-md-5 px-md-5">
                <div class="mx-auto">
                  <img
                    :src="require('../assets/logo-horizonal.svg')"
                    alt="마을예술창작소 로고"
                    class="logo w-50"
                  />
                </div>
                <section class="form-login my-5">
                  <b-form-input
                    v-model="email"
                    placeholder="이메일을 입력하세요"
                    type="email"
                    class="my-3"
                  >
                  </b-form-input>

                  <b-form-input
                    v-model="pwd"
                    placeholder="패스워드를 입력하세요"
                    type="password"
                    class="my-3"
                  >
                  </b-form-input>

                  <div class="my-4">
                    <button class="btn btn-primary" @click="login">
                      로그인
                    </button>
                  </div>
                </section>
              </div>
              <img
                :src="require('../assets/img/character-playing-both.png')"
                alt="로그인 캐릭터"
                class="position-absolute w-50 right-0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소 | 로그인",
    };
  },
  data() {
    return {
      email: "",
      pwd: "",
    };
  },
  methods: {
    async login() {
      try {
        const data = await this.$firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.pwd);
        if (data.user.email) {
          this.$router.push("/admin");
        }
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: "로그인에 실패했습니다.",
          autoHideDelay: 5000,
          variant: "error",
          toaster: "b-toaster-bottom-center",
        });
        console.error(error);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
